import React, { Component } from 'react';
import { QueryCSContext } from '../contexts/QueryCSContext';
import Button from '@material-ui/core/Button';
import './CodeSystemPage.css';

class CodeSystemPage extends Component {
	static contextType = QueryCSContext;

	handleClick() {
		document.getElementById('codeSystemBody__id').scroll({ top: 0, behavior: 'auto' });
	}

	render() {
		const { getNext, getPrev } = this.context;

		return (
			<div className="codeSystemPage">
				<Button
					variant="contained"
					size="small"
					color="primary"
					className="codeSystemPage__button"
					disabled={!this.props.prev}
					onClick={(x) => {
						this.handleClick();
						getPrev();
					}}
				>Prev</Button>
				<Button
					variant="contained"
					size="small"
					color="primary"
					className="codeSystemPage__button"
					disabled={!this.props.next}
					onClick={(x) => {
						this.handleClick();
						getNext();
					}}
				>Next</Button>
			</div>
		);
	}
}
export default CodeSystemPage;
